import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
  CNav,
  CNavItem,
  CNavLink,
  CTabs,
  CTabContent,
  CTabPane,
  CListGroup,
  CListGroupItem,
  CSidebar,
  CSidebarClose,
  CBadge,
  CLink
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { SET_ASIDE_SHOW } from '../redux/actions'
import { useQuery, useLazyQuery } from '@apollo/client';
import {  GET_NEARBY_POLL_MAPS_SAME_YEAR,
          GET_NEARBY_POLL_MAPS_HISTORY,
       } from '../apollo/queries' 
import { 
  SET_POLL_MAP, 
  SET_SEARCH_RESULTS, 
  SET_MAP_SELECTED, 
  SET_MAP_COUNT, 
  SET_POLL_MAP_YEAR, 
  SET_POLL_MAP_LOCAL_DIVISION 
} from '../redux/actions'

import { provinceShortToLong } from '../helpers/Utils'

const TheAside = (props) => {
  const show = useSelector(state => state.starter.asideShow)
  const mapCount = useSelector(state => state.starter.mapCount)
  const dispatch = useDispatch()
  const setState = (state) => dispatch({type: SET_ASIDE_SHOW, asideShow: state})
 
  const [nearbyPollMapsSameYear, setNearbyPollMapsSameYear] = useState(null)
  const [nearbyPollMapsHistory, setNearbyPollMapsHistory] = useState(null)

  var majj = props.majj
  var minj = props.minj
  var et = props.et
  
  const [doNearSameYear, { loading1, error1, data1 }] = useLazyQuery(GET_NEARBY_POLL_MAPS_SAME_YEAR);

  const [doNearHistory, { loading2, error2, data2 }] = useLazyQuery(GET_NEARBY_POLL_MAPS_HISTORY);

  // const { loading2, error2, data2 } = useQuery(GET_NEARBY_FEDERAL_POLL_MAPS_HISTORY, {onCompleted: setNearbyPollMapsHistory,
  //   variables: { year:String(props.year), lng:props.lng, lat:props.lat }
  // });

  const { loading3, error3, data3 } = useQuery(
    GET_NEARBY_POLL_MAPS_SAME_YEAR, {
      onCompleted: setNearbyPollMapsSameYear,
      variables: { 
        event_type:et,
        major_jurisdiction:majj,
        minor_jurisdiction:minj,
        local_division:String(props.ld), 
        year:String(props.year), 
        lng:props.lng, 
        lat:props.lat 
      }
  });

  const { loading4, error4, data4 } = useQuery(
    GET_NEARBY_POLL_MAPS_HISTORY, {
      onCompleted: setNearbyPollMapsHistory,
      variables: { 
        event_type:et,
        major_jurisdiction:majj,
        minor_jurisdiction:minj,
        local_division:String(props.ld), 
        year:String(props.year), 
        lng:props.lng, 
        lat:props.lat 
      }
  });

  useEffect(() => {
      doNearSameYear({
        onCompleted: setNearbyPollMapsSameYear,
        variables: { 
          event_type:et,
          major_jurisdiction:majj,
          minor_jurisdiction:minj,
          local_division:String(props.ld), 
          year:String(props.year), 
          lng:props.lng, 
          lat:props.lat 
        }
    });
      doNearHistory({
        onCompleted: setNearbyPollMapsHistory, variables: { 
        event_type:et,
        major_jurisdiction:majj,
        minor_jurisdiction:minj,
        local_division:String(props.ld), 
        year:String(props.year), 
        lng:props.lng, 
        lat:props.lat 
      }});
  }, [props, doNearHistory, doNearSameYear, et, majj, minj])

  const setNear = (result) => {
    dispatch({type: SET_POLL_MAP, pollMap: result})
    dispatch({type: SET_MAP_SELECTED, mapSelected: result})
    dispatch({type: SET_SEARCH_RESULTS, searchResults: false})
    dispatch({type: SET_POLL_MAP_YEAR, pollMapYear: result.year})
    dispatch({type: SET_POLL_MAP_LOCAL_DIVISION, pollMapLocalDivision: result.local_division})
    dispatch({type: SET_MAP_COUNT, mapCount: mapCount+1})
    dispatch({type: SET_ASIDE_SHOW, asideShow: false})
    //history.push('/political/canada/federal/election/'+result.year+'/'+result.local_division);
  }

  function compare( a, b ) {
    if ( a.year < b.year ){
      return 1;
    }
    if ( a.year > b.year ){
      return -1;
    }
    return 0;
  }  
  
  return (
    <CSidebar
      aside
      colorScheme='light'
      size='lg'
      overlaid
      show={show}
      className="overflow-auto"
      onShowChange={(state) => setState(state)}
    >
      <CSidebarClose onClick={() => setState(false) } />
      <CTabs>
        <CNav variant='tabs' className='nav-underline nav-underline-primary'>
          <CNavItem>
            <CNavLink style={{'&:hover':'grey'}}>
              <CIcon name="cil-cursor" alt="Nearby" />
            </CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink>
              <CIcon name="cil-calendar" alt="History" />
              </CNavLink>
            </CNavItem>
        </CNav>

        <CTabContent>
          <CTabPane>
            <CListGroup accent>
            { nearbyPollMapsSameYear !== null ?
                <CListGroupItem
                accent="secondary" 
                className="bg-light text-center font-weight-bold text-muted text-uppercase c-small"
                >
                Nearby Ridings
                </CListGroupItem>
            : <></>}
            { nearbyPollMapsSameYear !== null ? nearbyPollMapsSameYear.getPollMapsNearYear.map((r, i) => (
                <CLink style={{textDecoration:'none'}} key={i+1000} to={r.event_type === 'Federal' ? '/political/canada/federal/election/'+r.year+'/'+r.local_division : '/political/canada/'+r.event_type.toLowerCase()+'/election/'+provinceShortToLong(r.minor_jurisdiction).toLowerCase()+'/'+r.year+'/'+r.local_division} onClick={() => setNear(r)} >
                  <CListGroupItem accent="secondary" className="list-group-item-divider">
                    <div>
                      <CBadge className="mr-1 float-left" color={
                        r.hasOwnProperty('winner') ? 
                        r.winner === 'Conservative' ? "primary" : 
                        r.winner === "Liberal" ? "danger" : 
                        r.winner === "Ontario Liberal Party" ? "danger" : 
                        r.winner === "NDP" ? "warning" : 
                        r.winner === "Bloc Québécois" ? "info" : 
                        r.winner === "Canadian Alliance" ? "darkgreen" : 
                        r.winner === "Green Party" ? "success" : 
                        r.winner === "Green Party of Ontario" ? "success" : 
                        r.winner === "Ontario Green Party" ? "success" :                         
                        r.winner === "Progressive Conservative" ? "lightblue" : 
                        "secondary" : 
                        "secondary"
                      }>{r.year}</CBadge> {r.district}
                    </div>
                  <small className="text-muted mr-3"><CIcon name="cil-location-pin" />{r.minor_jurisdiction}</small>
                  </CListGroupItem>
                </CLink>
                )) : <></> }
            </CListGroup>
          </CTabPane>
          <CTabPane>
          {/* <CListGroup accent>
            { nearbyPollMapsHistory !== null ? 
                <CListGroupItem 
                  color="secondary" 
                  className="bg-light text-center font-weight-bold text-muted text-uppercase c-small"
                >
                    History
                </CListGroupItem>
                : <></>}
                { nearbyPollMapsHistory !== null ? nearbyPollMapsHistory.getPollMapsNearHistory.sort(compare).map((r, i) => (
                  <CLink style={{textDecoration:'none'}} key={i+1000} to={r.event_type === 'Federal' ? '/political/canada/federal/election/'+r.year+'/'+r.local_division : '/political/canada/'+r.event_type.toLowerCase()+'/election/'+provinceShortToLong(r.minor_jurisdiction).toLowerCase()+'/'+r.year+'/'+r.local_division} onClick={() => setNear(r)} >
                    <CListGroupItem onClick={() => setNear(r)} accent="secondary" className="list-group-item-divider">
                      <div>
                        <CBadge className="mr-1 float-left" color={
                          r.hasOwnProperty('winner') ? 
                          r.winner === 'Conservative' ? "primary" : 
                          r.winner === "Liberal" ? "danger" : 
                          r.winner === "NDP" ? "warning" : 
                          r.winner === "Bloc Québécois" ? "info" : 
                          r.winner === "Canadian Alliance" ? "darkgreen" : 
                          r.winner === "Green Party" ? "success" : 
                          r.winner === "Progressive Conservative" ? "lightblue" : 
                          "secondary" : 
                          "secondary"
                        }>{r.year}</CBadge> {r.district}
                      </div>
                      <small className="text-muted mr-3"><CIcon name="cil-location-pin" />{r.minor_jurisdiction}</small>
                    </CListGroupItem>
                  </CLink>
              )) : <></> }
            </CListGroup> */}
          </CTabPane>
        </CTabContent>
      </CTabs>
    </CSidebar>
  )
}

export default TheAside;
